import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpsertPersonStatus, MutationUpsertApteanAdminArgs } from '../gql-types.generated';
import { getStandardHeaders } from '../util/StandardRequestHeaders';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPSERT_APTEAN_ADMIN = gql`
  mutation upsertApteanAdmin($input: UpsertApteanAdminInput!) {
    upsertApteanAdmin(input: $input) {
      code
      message
      error
    }
  }
`;

export const mutationUpsertApteanAdmin = async (
  client: ApolloClient<NormalizedCacheObject>,
  options: {
    email: string;
    id?: string;
    firstName?: string;
    lastName?: string;
  },
): Promise<UpsertPersonStatus | undefined> => {
  const { email, id, firstName, lastName } = options;
  const headers = await getStandardHeaders(true);
  const { data, errors } = await client.mutate<{ upsertApteanAdmin: UpsertPersonStatus }, MutationUpsertApteanAdminArgs>({
    variables: { input: { id, firstName, lastName, email } },
    mutation: MUTATION_UPSERT_APTEAN_ADMIN,
    context: { headers },
  });
  if (errors && errors.length > 0) {
    errors.forEach(error => console.error(error));
    throw new Error('An error has occurred during the aptean admin upsert.');
  }
  if (data && data.upsertApteanAdmin) {
    return data.upsertApteanAdmin;
  }
  return undefined;
};
